import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Inicio from './Components/Inicio';
import Registro from './views/Registro/registro';
import Resumen from './views/Resumen/resumen';
import TipoInversion from './views/TipoInversion/TipoInversion';
import Meta from './views/Meta/meta';
import Reporte from './views/Inversiones/Inversiones';
import Detalle from './views/Inversiones/DetalleInversion';
import Finalizar from './views/misc/Finalizar';
import EditorMetas from './views/cms/EditorMetas';

function App() {
  //const {data,loading,error} = useFetch("https://jsonplaceholder.typicode.com/users")
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        <Route path="*" element={<Inicio to="/" />} ></Route>
        <Route path="/registro" element={<Registro />} ></Route>
        <Route path="/resumen" element={<Resumen />} ></Route>
        <Route path="/tipo" element={<TipoInversion />} ></Route>
        <Route path="/meta" element={<Meta />} ></Route>
        <Route path="/meta" element={<Meta />} ></Route>
        <Route path="/reporte" element={<Reporte />} ></Route>
        <Route path="/detalle" element={<Detalle />} ></Route>
        <Route path="/Finalizar" element={<Finalizar />} ></Route>
        <Route path="/cms" element={<EditorMetas />} ></Route>
        {/*<Route path="/resumen/:code" element={<Resumen />} ></Route>*/}
      </Routes>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
}
/**
 *       <div>fetch</div>
      <ul>
        {error && <li>Error: {error}</li>}
        {loading && <li>loading</li>}
        {data?.map((user)=>(
          <li key={user.id}>{user.name}</li>
        ))}
      </ul>
      <div>más fetch</div>
 * 
 */
export default App;
